<template>
  <div>
    <!-- Table Herança -->
    <v-data-table
      v-model="herancas.selecionados"
      :headers="herancas.headers"
      :items="herancas.itens"
      :fixed-header="true"
      :search="herancas.search"
      :items-per-page="50"
      item-key="id"
      class="table-heranca-resposivo"
      show-select
    >
      <template v-slot:top>
        <v-toolbar flat color="white">
          <v-toolbar-title>Produtos com Herança</v-toolbar-title>
          <v-spacer></v-spacer>
          <v-divider class="mx-4" inset vertical></v-divider>
          <v-text-field
            v-model="herancas.search"
            append-icon="mdi-magnify"
            label="Pesquisar"
            dense
            outlined
            single-line
            hide-details
            clearable
            v-lazy-input:debounce="400"
            class="search"
          ></v-text-field>
          <v-divider class="mx-4" inset vertical v-if="herancas.selecionados.length > 0"></v-divider>
          <v-btn
            color="red"
            dark
            class="mr-2"
            @click="excluir()"
            v-if="herancas.selecionados.length > 0"
          >
            <v-icon>mdi-delete</v-icon>
            Remover ({{ herancas.selecionados.length }})
          </v-btn>
          <v-divider class="mx-4" inset vertical></v-divider>
          <v-btn color="primary" @click="herancas.dialog = true">Novo</v-btn>
        </v-toolbar>
      </template>
      <template
        v-slot:item.tipo_heranca="{ item }"
      >{{ selects.tipo.find(i => i.value == item.tipo_heranca).text }}</template>
      <template v-slot:item.id_produto="{ item }">{{ item.id_produto }} - {{ item.produto }}</template>
      <template v-slot:item.heranca_id="{ item }">{{ item.heranca_id }} - {{ item.heranca }}</template>
      <template v-slot:item.action="{ item }">
        <v-btn icon title="Remover Item" @click="excluir(item)">
          <v-icon>mdi-delete</v-icon>
        </v-btn>
      </template>
    </v-data-table>
    <!-- Modal Novo -->
    <v-dialog
      v-model="herancas.dialog"
      fullscreen
      hide-overlay
      transition="dialog-bottom-transition"
      persistent
    >
      <v-card class="rounded-0 heranca-item">
        <v-toolbar dark color="#042333">
          <v-btn icon dark @click="fechar">
            <v-icon>mdi-close</v-icon>
          </v-btn>
          <v-toolbar-title>Cadastro de itens com herança</v-toolbar-title>
        </v-toolbar>
        <v-card-text style="height: calc(100vh - 117px)" class="pa-0">
          <v-row class="ma-0">
            <v-col cols="4">
              <v-card v-if="filho.itens.length == 0 && filho.search.length == 0">
                <v-toolbar style="border-bottom: 1px solid #e0e0e0;" flat height="50px">
                  <v-toolbar-title class="subtitle-2">Produto Filho</v-toolbar-title>
                </v-toolbar>
                <v-card-text style="height: calc(100vh - 191px);overflow: auto;">
                  <v-select
                    v-model="form.grupo"
                    :items="selects.grupos"
                    label="Grupo Compras*"
                    outlined
                    autofocus
                    :error-messages="errorGrupo"
                    @change="buscarFornecedores()"
                    @input="$v.form.grupo.$touch()"
                    @blur="$v.form.grupo.$touch()"
                  ></v-select>
                  <v-autocomplete
                    v-model="form.fornecedor"
                    :items="selects.fornecedores"
                    label="Fornecedores*"
                    clearable
                    outlined
                    :error-messages="errorFornecedor"
                    @input="$v.form.fornecedor.$touch()"
                    @blur="$v.form.fornecedor.$touch()"
                    :disabled="!form.grupo"
                  ></v-autocomplete>
                  <v-autocomplete
                    v-model="form.filtros"
                    :items="selects.filtros"
                    label="Filtros"
                    multiple
                    clearable
                    outlined
                    @change="buscarDepartamentos()"
                    :disabled="!form.fornecedor"
                  ></v-autocomplete>
                  <v-autocomplete
                    v-model="form.departamentos"
                    :items="selects.departamentos"
                    label="Departamentos"
                    multiple
                    clearable
                    outlined
                    v-if="form.filtros.includes(2)"
                  ></v-autocomplete>
                </v-card-text>
                <v-card-actions>
                  <v-spacer></v-spacer>
                  <v-btn color="#042333" dark @click="buscarProdutos">Pesquisar</v-btn>
                </v-card-actions>
              </v-card>
              <v-card v-else>
                <v-toolbar style="border-bottom: 1px solid #e0e0e0;" height="50px" flat>
                  <v-btn icon @click="filho.voltar">
                    <v-icon>mdi-chevron-left</v-icon>
                  </v-btn>
                  <v-toolbar-title class="subtitle-2">{{ filho.title }}</v-toolbar-title>
                </v-toolbar>
                <v-toolbar height="50px" color="white" class="pa-0" elevation="1">
                  <v-text-field
                    v-model="filho.search"
                    label="Pesquisar"
                    prepend-inner-icon="mdi-magnify"
                    outlined
                    dense
                    single-line
                    hide-details
                    v-lazy-input:debounce="300"
                  ></v-text-field>
                </v-toolbar>
                <v-virtual-scroll
                  :items="filho.itens"
                  item-height="40px"
                  height="calc(100vh - 188px)"
                >
                  <template v-slot:default="{ item }">
                    <v-list-item>
                      <v-list-item-action class="mr-3">
                        <v-checkbox
                          v-model="filho.selecionado"
                          :value="item.id_produto"
                          :multiple="false"
                        ></v-checkbox>
                      </v-list-item-action>
                      <v-list-item-content>
                        <v-list-item-title>{{ item.id_produto }} - {{ item.produto }}</v-list-item-title>
                      </v-list-item-content>
                    </v-list-item>
                    <v-divider style="margin-top: -5px;" />
                  </template>
                </v-virtual-scroll>
              </v-card>
            </v-col>
            <v-col cols="4">
              <v-card>
                <v-toolbar style="border-bottom: 1px solid #e0e0e0;" height="50px" flat>
                  <v-toolbar-title class="subtitle-2">Herança Pai</v-toolbar-title>
                </v-toolbar>
                <v-toolbar
                  height="50px"
                  color="white"
                  class="pa-0"
                  elevation="1"
                  v-if="!(pai.search.length == 0 && pai.itens.length == 0)"
                >
                  <v-text-field
                    label="Pesquisar"
                    prepend-inner-icon="mdi-magnify"
                    outlined
                    dense
                    single-line
                    hide-details
                    v-model="pai.search"
                    v-lazy-input:debounce="300"
                  ></v-text-field>
                </v-toolbar>
                <v-virtual-scroll
                  :items="pai.itens"
                  item-height="40px"
                  height="calc(100vh - 188px)"
                  v-if="!(pai.search.length == 0 && pai.itens.length == 0)"
                >
                  <template v-slot:default="{ item }">
                    <v-list-item>
                      <v-list-item-action class="mr-3">
                        <v-checkbox
                          v-model="pai.selecionado"
                          :value="item.id_produto"
                          :multiple="false"
                        ></v-checkbox>
                      </v-list-item-action>
                      <v-list-item-content>
                        <v-list-item-title>{{ item.id_produto }} - {{ item.produto }}</v-list-item-title>
                      </v-list-item-content>
                    </v-list-item>
                    <v-divider style="margin-top: -5px;" />
                  </template>
                </v-virtual-scroll>
                <div v-else style="height:calc(100vh - 138px)"></div>
              </v-card>
            </v-col>
            <v-col cols="4">
              <v-card>
                <v-toolbar style="border-bottom: 1px solid #e0e0e0;" flat height="50px">
                  <v-toolbar-title class="subtitle-2">Itens com Herança</v-toolbar-title>
                </v-toolbar>
                <v-list style="height: calc(100vh - 191px);overflow: auto;">
                  <v-list-item-group v-if="herdeiros.itens.length > 0">
                    <v-list-item v-for="(h, k) in herdeiros.itens" :key="k">
                      <v-list-item-content>
                        <v-list-item-title>{{ h.filho }} - {{ itens.find(i => i.id_produto == h.filho).produto }}</v-list-item-title>
                        <v-list-item-title>{{ h.pai }} - {{ itens.find(i => i.id_produto == h.pai).produto }}</v-list-item-title>
                        <v-list-item-title>{{ selects.tipo.find(i => i.value == h.tipo).text }}</v-list-item-title>
                      </v-list-item-content>
                      <v-list-item-action>
                        <v-btn icon title="Remover Item" @click="herdeirosExcluir(h)">
                          <v-icon>mdi-delete</v-icon>
                        </v-btn>
                      </v-list-item-action>
                    </v-list-item>
                  </v-list-item-group>
                </v-list>
                <v-card-actions>
                  <v-spacer></v-spacer>
                  <v-btn
                    color="#042333"
                    class="white--text"
                    @click="salvar"
                    :disabled="herdeiros.itens.length == 0"
                  >Salvar</v-btn>
                </v-card-actions>
              </v-card>
            </v-col>
          </v-row>
        </v-card-text>
      </v-card>
    </v-dialog>
    <!-- Modal tipo Herança -->
    <v-dialog persistent v-model="tipo.dialog" max-width="600px">
      <v-card style="border: 1px solid #fff">
        <v-toolbar dark color="#042333" height="50px">
          <v-btn icon dark @click="tipo.fechar">
            <v-icon>mdi-close</v-icon>
          </v-btn>
          <v-toolbar-title>Tipo de herança</v-toolbar-title>
        </v-toolbar>
        <v-card-text style="min-height: 67vh" class="pb-0 row ma-0" v-if="tipo.dialog">
          <div class="col-12">
            <div class="pt-5">
              Produto Filho:
              <b>{{ filho.selecionado }} - {{ itens.find(i => i.id_produto == filho.selecionado).produto }}</b>
            </div>
            <div class="py-4">
              Produto Pai:
              <b>{{ pai.selecionado }} - {{ itens.find(i => i.id_produto == pai.selecionado).produto }}</b>
            </div>
            <v-select
              v-model="tipo.form.tipo"
              :items="selects.tipo"
              label="Selecione o tipo de herança*"
              class="mt-4"
              outlined
              @input="$v.tipo.form.tipo.$touch()"
              @blur="$v.tipo.form.tipo.$touch()"
              :error-messages="errorTipo"
              @change="buscarDadosGraficoPrimeiroSemestre()"
            ></v-select>
            <div v-if="this.tipo.form.tipo == 1">
              <h3 class="pt-0 mt-0">Saídas do 1° semestre</h3>
              <p class="pb-0 mb-0">
                Período:
                <span v-if="grafico.detalhes.data_ini">
                  {{ grafico.detalhes.data_ini }} -
                  {{ grafico.detalhes.data_fim_grafico }}
                </span>
                <span v-else>sem dados</span>
              </p>
              <chart-saidas-produto :dados="grafico.dados" style="height: 175px" />
              <div class="row">
                <div class="col-4" style="text-align: center">
                  <span>Média 3 Meses:</span>
                  {{
                  Helpers.formatarValor(grafico.projecaoMedia.media_trimestral)
                  }}
                </div>
                <div class="col-4" style="text-align: center">
                  <span>Média 6 Meses:</span>
                  {{ Helpers.formatarValor(grafico.projecaoMedia.media_semestral) }}
                </div>
                <div class="col-4" style="text-align: center">
                  <span>Projeção de vendas:</span>
                  {{ Helpers.formatarValor(grafico.projecaoMedia.projecao) }}
                </div>
              </div>
            </div>
          </div>
        </v-card-text>

        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn color="white" @click="tipo.fechar">Cancelar</v-btn>
          <v-btn color="#042333" dark @click="adicionar">Adicionar</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </div>
</template>

<script>
import { required } from "vuelidate/lib/validators";
import DrpAPI from "./../../api/heranca.js";
import ChartSaidasProduto from "../compra/ChartSaidasProduto";

export default {
  components: { ChartSaidasProduto },
  data() {
    return {
      itens: [],
      herancas: {
        headers: [
          { text: "Fornecedor", value: "fornecedor" },
          { text: "Produto", value: "id_produto" },
          { text: "", value: "produto", class: "d-none", cellClass: "d-none" },
          { text: "Tipo de Herança", value: "tipo_heranca" },
          { text: "Herança", value: "heranca_id" },
          { text: "", value: "heranca", class: "d-none", cellClass: "d-none" },
          { value: "action", sortable: false, width: "100px", align: "center" }
        ],
        search: "",
        itens: [],
        dialog: false,
        selecionados: []
      },
      filho: {
        header: [{ text: "Descrição", value: "produto" }],
        selecionado: [],
        title: "",
        search: "",
        itens: [],
        voltar: () => {
          this.filho.itens = [];
          this.filho.selecionado = [];
          this.tipo.form = {
            tipo: ""
          };
          this.pai.selecionado = [];
          this.pai.itens = [];
          this.$v.$reset();
        }
      },
      pai: {
        header: [
          { text: "#", value: "id_produto", width: "77px", align: "center" },
          { text: "Descrição", value: "produto" }
        ],
        selecionado: [],
        search: "",
        itens: []
      },
      herdeiros: {
        itens: [],
        grupo: ""
      },
      selects: {
        fornecedores: [],
        grupos: [],
        tipo: [
          { value: 1, text: "Lançamento" },
          { value: 2, text: "Continua" }
        ],
        filtros: [
          { value: 1, text: "Itens Novos" },
          { value: 2, text: "Departamentos" }
        ],
        departamentos: []
      },
      form: {
        grupo: "",
        fornecedor: "",
        filtros: [],
        departamentos: []
      },
      tipo: {
        dialog: false,
        form: {
          tipo: ""
        },
        fechar: () => {
          this.tipo.dialog = false;
          this.tipo.form = {
            tipo: ""
          };
          this.pai.selecionado = [];
          this.filho.selecionado = [];
          this.pai.itens = [];
          this.$v.$reset();
        }
      },
      grafico: {
        dados: [],
        projecaoMedia: {},
        detalhes: {}
      }
    };
  },
  validations: {
    form: {
      grupo: { required },
      fornecedor: { required }
    },
    tipo: {
      form: {
        tipo: { required }
      }
    }
  },
  computed: {
    errorGrupo() {
      const errors = [];
      if (!this.$v.form.grupo.$dirty) return errors;
      !this.$v.form.grupo.required && errors.push("O grupo é obrigatório.");
      return errors;
    },
    errorFornecedor() {
      const errors = [];
      if (!this.$v.form.fornecedor.$dirty) return errors;
      !this.$v.form.fornecedor.required &&
        errors.push("A fornecedor é obrigatória.");
      return errors;
    },
    errorTipo() {
      const errors = [];
      if (!this.$v.tipo.form.tipo.$dirty) return errors;
      !this.$v.tipo.form.tipo.required && errors.push("O tipo é obrigatório.");
      return errors;
    }
  },
  created() {
    this.listar();
    DrpAPI.Listar({ getGrupo: true }).then(resp => {
      this.selects.grupos = resp;
    });
  },
  methods: {
    listar() {
      this.herancas.itens = [];
      DrpAPI.Listar().then(resp => {
        this.herancas.itens = resp;
      });
    },
    salvar() {
      this.$v.$touch();
      if (!this.$v.form.$invalid) {
        this.herdeiros.grupo = this.form.grupo;
        DrpAPI.Salvar(this.herdeiros).then(resp => {
          this.herancas.itens = resp;
          this.herdeiros = {
            itens: [],
            grupo: ""
          };
          this.fechar();
        });
        this.$v.$reset();
      }
    },
    excluir(prop) {
      if (!prop) {
        prop = { ids: [] };
        this.herancas.selecionados.forEach(hs => {
          prop.ids.push({ id: hs.id_produto, id_grupo: hs.id_grupo });
        });
      }
      if (confirm("Deseja realmente EXCLUIR?")) {
        DrpAPI.Excluir(prop).then(resp => {
          this.herancas.itens = resp;
          this.herancas.selecionados = [];
        });
      }
    },
    fechar() {
      if (this.herdeiros.itens.length > 0) {
        if (!confirm("Deseja realmente EXCLUIR?")) {
          return;
        }
      }
      this.herancas.dialog = false;
      this.form = {
        grupo: "",
        fornecedor: "",
        filtros: []
      };
      this.herdeiros = {
        itens: [],
        grupo: ""
      };
      this.pai.selecionado = [];
      this.filho.selecionado = [];
      this.filho.itens = [];
      this.pai.itens = [];
      this.$v.$reset();
    },
    adicionar() {
      this.$v.$touch();
      if (!this.$v.tipo.form.$invalid) {
        this.herdeiros.itens.push({
          tipo: this.tipo.form.tipo,
          pai: this.pai.selecionado,
          filho: this.filho.selecionado
        });
        this.tipo.dialog = false;
        this.filho.itens = this.filho.itens.filter(
          fi => fi.id_produto != this.filho.selecionado
        );
        this.pai.selecionado = [];
        this.tipo.form.tipo = "";
        this.pai.search = "";
        this.pai.itens = [];
        this.filho.selecionado = [];
        this.filho.search = "";
        this.$v.$reset();
      }
    },
    buscarFornecedores() {
      DrpAPI.Listar({ getFornecedor: true, grupo: this.form.grupo }).then(
        resp => {
          this.selects.fornecedores = resp;
        }
      );
    },
    buscarDepartamentos() {
      if (this.form.filtros.includes(2)) {
        DrpAPI.Listar({
          getDepartamento: true,
          grupo: this.form.grupo,
          fornecedor: this.form.fornecedor
        }).then(resp => {
          this.selects.departamentos = resp;
        });
      }
    },
    buscarProdutos() {
      this.$v.$touch();
      if (!this.$v.form.$invalid) {
        DrpAPI.Listar({
          getProdutos: true,
          grupo: this.form.grupo
        }).then(resp => {
          this.itens = resp;
          this.filho.title = this.selects.fornecedores.find(
            sf => sf.value == this.form.fornecedor
          ).text;
        });
      }
    },
    buscarDadosGraficoPrimeiroSemestre() {
      if (this.tipo.form.tipo == 1) {
        DrpAPI.Listar({
          getGrafico: true,
          idproduto: this.pai.selecionado,
          grupo: this.form.grupo
        }).then(response => {
          this.grafico.dados = response.dados;
          this.grafico.projecaoMedia = response.projecaoMedia;
          this.grafico.detalhes = response.detalhes;
        });
      }
    },
    herdeirosExcluir(props) {
      if (confirm("Deseja remover o item?")) {
        this.herdeiros.itens.splice(this.herdeiros.itens.indexOf(props), 1);
      }
    }
  },
  watch: {
    itens() {
      if (this.itens.length > 0) {
        this.filho.itens = [
          ...this.itens.filter(
            fi => fi.idfornecedor == this.form.fornecedor && !fi.heranca
          )
        ];
        if (
          this.form.filtros.includes(2) &&
          this.form.departamentos.length > 0
        ) {
          this.filho.itens = [
            ...this.filho.itens.filter(function(e) {
              return this.indexOf(e) < 0;
            }, this.form.departamentos)
          ];
        }
        if (this.form.filtros.includes(1)) {
          this.filho.itens = [
            ...this.filho.itens.filter(fi => fi.data_cadastro <= 90)
          ];
          if (this.filho.itens.length == 0) {
            alert("Não existe itens novos");
          }
        }
        this.filho.itens = this.filho.itens.filter(function(e) {
          return this.indexOf(e) < 0;
        }, this.herdeiros.itens);
        if (this.filho.itens.length == 0 && this.filho.itens.length > 0) {
          alert("Não existe itens");
        }
      } else {
        this.filho.itens = [];
        this.pai.itens = [];
      }
    },
    "form.fornecedor"() {
      this.form.filtros = [];
      this.form.departamentos = [];
    },
    "filho.search"() {
      this.filho.itens = [];
      this.filho.itens = [
        ...this.itens.filter(fi => fi.idfornecedor == this.form.fornecedor)
      ];

      if (this.form.filtros.includes(2) && this.form.departamentos.length > 0) {
        this.filho.itens = [
          ...this.filho.itens.filter(function(e) {
            return this.indexOf(e) < 0;
          }, this.form.departamentos)
        ];
      }
      if (this.form.filtros.includes(1)) {
        this.filho.itens = [
          ...this.filho.itens.filter(fi => fi.data_cadastro <= 90)
        ];
        if (this.filho.itens.length == 0) {
          alert("Não existe itens novos");
        }
      }

      this.filho.itens = this.filho.itens.filter(
        fi =>
          fi.produto.toLowerCase().indexOf(this.filho.search.toLowerCase()) >
            -1 ||
          fi.id_produto.toLowerCase().indexOf(this.filho.search.toLowerCase()) >
            -1
      );
      this.filho.selecionado = [];
    },
    "pai.search"() {
      this.pai.itens = [
        ...this.itens.filter(i => i.id_produto != this.filho.selecionado)
      ];
      this.pai.itens = this.pai.itens.filter(
        pi =>
          pi.produto.toLowerCase().indexOf(this.pai.search.toLowerCase()) >
            -1 ||
          pi.id_produto.toLowerCase().indexOf(this.pai.search.toLowerCase()) >
            -1
      );
      this.pai.selecionado = [];
    },
    "filho.selecionado"() {
      this.pai.selecionado = [];
      if (this.filho.selecionado && this.filho.selecionado.length > 0) {
        this.pai.itens = [
          ...this.itens.filter(i => i.id_produto != this.filho.selecionado)
        ];
      } else {
        this.pai.itens = [];
      }
    },
    "pai.selecionado"() {
      if (
        this.pai.selecionado.length > 0 &&
        this.filho.selecionado.length > 0
      ) {
        this.tipo.dialog = true;
        this.grafico = {
          dados: [],
          projecaoMedia: {},
          detalhes: {}
        };
        this.$v.$touch();
      }
    }
  }
};
</script>

<style>
.table-heranca-resposivo .v-data-table__wrapper {
  height: calc(100vh - 219px) !important;
}
.table-heranca-resposivo .v-data-table__wrapper table thead tr th {
  vertical-align: top !important;
  padding-left: 6px !important;
  padding-right: 6px;
  padding-top: 5px !important;
  font-size: 9pt !important;
}
.table-heranca-resposivo .v-data-table__wrapper table tbody tr td {
  font-size: 9pt !important;
}

.heranca-item input,
.heranca-item select,
.heranca-item .v-select {
  font-size: 9pt;
}
</style>
